module.exports = __webpack_public_path__ + "img/9.093c8a60.jpg";